<template>
  <v-dialog v-model="mostradoModal" max-width="1200" scrollable>
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Módulos en los que está inscrito</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <v-simple-table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>N° Módulo</th>
                  <th>Módulo</th>
                  <th>Fecha Inicio</th>
                  <th>Fecha Fin</th>
                  <th>Fecha Registro</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(item, indice) in inscripcionesModulosOrdenados"
                  :key="indice"
                  :style="{ backgroundColor: indice == inscripcionesModulos.length - 1 ? '#E3F2FD' : '' }">
                  <td>{{ indice + 1 }}</td>
                  <td class="text-right">
                    {{ item.programaModulo?.numero.toString() }}
                  </td>
                  <td>
                    {{ item.programaModulo?.modulo?.nombre }}
                  </td>
                  <td>
                    {{ item.programaModulo.fechaInicio || '-' }}
                  </td>
                  <td>
                    {{ item.programaModulo.fechaFin || '-' }}
                  </td>
                  <td>
                    {{ formatearFechaYHoraBoliviana(item.fechaRegistro) }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue darken-1" text @click="mostradoModal = false"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatearFechaYHoraBoliviana } from '../utils/funciones';

export default {
  name: 'ModalModulosInscritos',
  props: {
    inscripcionesModulos: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    inscripcionesModulosOrdenados() {
      const inscripcionesModulos = this.inscripcionesModulos.map((im) => ({
        ...im,
        numero: Number(im.programaModulo?.numero),
      }));

      return inscripcionesModulos.sort((a, b) => {
        return a.numero - b.numero;
      });
    },
  },
  data() {
    return {
      mostradoModal: false,
    };
  },
  methods: {
    abrir() {
      this.mostradoModal = true;
    },
    formatearFechaYHoraBoliviana(fecha) {
      return formatearFechaYHoraBoliviana(fecha);
    },
  },
};
</script>

<style>
</style>